import React from 'react';
import { emojiFlags } from './EmojiConsts';
import Emoji from './Emoji';

const EmojiFlag = ({ tld }) => {
    // Safety check: ensure tld exists and is a string before calling toUpperCase
    if (!tld || typeof tld !== 'string') {
        return null;
    }
    
    // Convert TLD to uppercase to match the keys in emojiFlags
    const countryCode = tld.toUpperCase();
    const flag = emojiFlags[countryCode] || {};

    return (
        <>
            {flag ? <Emoji unicode={flag?.unicode} label={flag?.description} /> : null}
        </>
    );
};

export default EmojiFlag;
